export const ALL_DEVICES_KEY = 'all'
